// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sbscr .sbscr-agreement {\n    display: block;\n    text-align: center;\n    opacity: 0.85;\n    font-size: 11px;\n  }\n  .sbscr .sbscr-agreement a {\n    color: var(--secondary-bg-text-color);\n    line-height: 16px;\n    text-decoration: underline;\n  }\n", ""]);
// Exports
module.exports = exports;
